module.exports = __webpack_public_path__ + "img/ape-bg.33376c6c.png";